/**
 * Helpers for `attachedKnowledge` on skills:
 *   attachedKnowledge: Array<{ knowledge?: ObjectId, usage?: string }>
 */

export function attachmentKnowledgeKey(att) {
  if (!att?.knowledge) return '';
  return `knowledge:${String(att.knowledge)}`;
}

export function attachedKnowledgeIdSet(attachments = []) {
  return new Set(attachments.filter(a => a?.knowledge).map(a => String(a.knowledge)));
}

export function isKnowledgeAttached(attachments, knowledgeId) {
  return attachedKnowledgeIdSet(attachments).has(String(knowledgeId));
}

export function findKnowledgeAttachment(attachments = [], knowledgeId) {
  return attachments.find(a => a.knowledge && String(a.knowledge) === String(knowledgeId));
}

export function attachKnowledge(attachments = [], knowledgeId, usage = '') {
  if (isKnowledgeAttached(attachments, knowledgeId)) return attachments;
  return [...attachments, { knowledge: knowledgeId, usage }];
}

export function detachKnowledge(attachments = [], knowledgeId) {
  return attachments.filter(a => !(a.knowledge && String(a.knowledge) === String(knowledgeId)));
}

export function setKnowledgeAttachmentUsage(attachments = [], knowledgeId, usage) {
  return attachments.map(a => {
    if (a.knowledge && String(a.knowledge) === String(knowledgeId)) return { ...a, usage };
    return a;
  });
}

export function sanitizeKnowledgeAttachmentsForApi(attachments = []) {
  return attachments
    .filter(a => a?.knowledge)
    .map(a => ({ knowledge: String(a.knowledge), usage: a.usage || '' }));
}
